import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { newsData } from '../data/newsData';
import './NewsComponent.css';

const NewsComponent = () => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Sort and get the latest news item for the home page highlight
  const latestNews = [...newsData].sort((a, b) =>
    new Date(b.publishDate) - new Date(a.publishDate)
  )[0];

  const newsImages = latestNews?.images || [];

  const nextImage = useCallback(() => {
    setCurrentImageIndex((prev) => (prev + 1) % newsImages.length);
  }, [newsImages.length]);

  useEffect(() => {
    if (newsImages.length < 2) return undefined;
    const interval = setInterval(nextImage, 4000);
    return () => clearInterval(interval);
  }, [nextImage, newsImages.length]);

  if (!latestNews) return null;

  const displayLead = Array.isArray(latestNews.lead)
    ? latestNews.lead[0]
    : latestNews.lead;

  return (
    <section id="news" className="news-component-container">
      <div className="news-split-layout">
        {/* Left Side: News Content */}
        <div className="news-content-box">
          <div className="news-content-inner">
            <span className="news-tag">{latestNews.tag}</span>
            <h2 className="news-title">{latestNews.title}</h2>
            <div className="news-date">{latestNews.date}</div>
            <p className="news-summary">{latestNews.summary}</p>
            {displayLead && <p className="news-lead">{displayLead}</p>}
          </div>
          <button
            className="read-full-btn"
            onClick={() => navigate(`/news/${latestNews.slug}`)}
          >
            Read Full Story <span>→</span>
          </button>
        </div>

        {/* Right Side: Mini-Carousel */}
        <div className="news-carousel-box">
          <div className="mini-carousel-wrapper">
            {newsImages.map((img, index) => (
              <div
                key={index}
                className={`mini-slide ${index === currentImageIndex ? 'active' : ''}`}
              >
                <img src={img} alt={`${latestNews.title} (${index + 1})`} />
              </div>
            ))}
            <div className="mini-carousel-overlay">
              <div className="mini-progress-dots">
                {newsImages.map((_, index) => (
                  <div
                    key={index}
                    className={`mini-dot ${index === currentImageIndex ? 'active' : ''}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsComponent;
